// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import {fetch} from 'wix-fetch';

$w.onReady(function () {
	//TODO: write your page related code here...
	
});

export function btnSubmitPledge_click(event) 
{
	/*const url = "https://hooks.zapier.com/hooks/catch/2264800/o8usqqg/silent/";
 
	let fName = $w("#txtFName").value;
 	let lName = $w("#txtLName").value;
 	let email = $w("#txtEmail").value;
 	let state = $w("#selState").value;
	let reason = $w("#selReason").value; 
	let data = {
			"fname": fName,
			"lname": lName,
			"email": email,
			"state": state,
			"reason": reason
		};
		console.log(data);
	
	var bodyData = JSON.stringify(data);
	
	fetch(url, {method: 'post', body: bodyData})
	.then ((httpResponse)=>{
     if(httpResponse.ok){
      return httpResponse.json();
	 }else{
      return Promise.reject("Fetch did not succeed");
	 }})
	 .then(json=>{
		console.log(JSON.stringify(json));
	    $w("#btnSubmitPledge").disable();
		$w("#btnSubmitPledge").label="Thank you for submitting your pledge!";
	})
	.catch(err=>console.log(err));*/
}